import { render, staticRenderFns } from "./site-email.vue?vue&type=template&id=6fde5dd0&scoped=true"
import script from "./site-email.vue?vue&type=script&lang=js"
export * from "./site-email.vue?vue&type=script&lang=js"
import style0 from "./site-email.vue?vue&type=style&index=0&id=6fde5dd0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde5dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fde5dd0')) {
      api.createRecord('6fde5dd0', component.options)
    } else {
      api.reload('6fde5dd0', component.options)
    }
    module.hot.accept("./site-email.vue?vue&type=template&id=6fde5dd0&scoped=true", function () {
      api.rerender('6fde5dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/site/site-email.vue"
export default component.exports